/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Optimisée par Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Optimisé par AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Le contenu est basé sur vos autorisations, et sa qualité peut varier',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'La qualité du contenu est susceptible de varier',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "Utilise l'IA. Vérifiez les résultats.",
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informations',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inclure les connaissance de la page actuelle',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Retour',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annuler',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Échap',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annuler',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annuler',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Mauvaise réponse',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback envoyé',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Bonne réponse',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Continuer à partir de la dernière réponse',
  'fabric.editor.ai.config.item.action.copyResponse': 'Copier',
  'fabric.editor.ai.config.item.action.responseCopied': 'Copiée !',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copiée dans le presse-papiers',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Réessayer',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Nous rencontrons un problème pour insérer la réponse. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    "Impossible d'obtenir une réponse. Votre invite ou votre réponse a dépassé la limite fixée pour cette demande. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.experience.apiError': "Impossible d'obtenir une réponse, veuillez réessayer.",
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': "Dites à l'IA ce qu'elle doit faire...",
  'fabric.editor.ai.experience.inputTooShortError':
    'Le contenu est trop court pour être résumé. Veuillez ajouter du contenu, puis réessayez.',
  'fabric.editor.ai.experience.loadingAriaNewTitle': "Rovo est à l'œuvre",
  'fabric.editor.ai.experience.loadingAriaTitle': 'Génération',
  'fabric.editor.ai.experience.loadingEditingTitle': "Rovo est en cours d'édition",
  'fabric.editor.ai.experience.previewScreenLabel': 'Prévisualiser',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    "Demandez à l'agent d'écrire quelque chose ou choisissez parmi les options ci-dessous",
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Retour',
  'fabric.editor.ai.screens.discard.deleteLabel': 'Supprimer',
  'fabric.editor.ai.screens.discard.discardLabel': 'Ignorer',
  'fabric.editor.ai.screens.discard.keepLabel': 'Conserver',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Avertissement',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Erreur',
  'fabric.editor.ai.screens.error.cancelLabel': 'Annuler',
  'fabric.editor.ai.screens.error.closeLabel': 'Fermer',
  'fabric.editor.ai.screens.error.retryLabel': 'Réessayer',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Contenu mis à jour en temps réel :',
  'fabric.editor.ai.screens.loading.iconAltText': "Génération d'une icône",
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Aucune amélioration, bon travail.',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Opération réussie',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Accepter',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': "Actions pour le contenu généré par l'IA",
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Réessayer',
  'fabric.editor.ai.screens.preview.betaLabel': 'Bêta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Annuler',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Est-ce utile ?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': "Dire à AI ce qu'il doit faire ensuite",
  'fabric.editor.ai.screens.preview.discardLabel': 'Ignorer',
  'fabric.editor.ai.screens.preview.disclaimer': 'La qualité des informations peut varier.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Découvrez pourquoi',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Effacer',
  'fabric.editor.ai.screens.preview.header.edit': "Modifier l'invite",
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Modifier',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Demander à {agentName} quoi faire ensuite',
  'fabric.editor.ai.screens.preview.refineButton': 'Affiner',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Affiner',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Ajouter un lien',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Mentionner un utilisateur',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Insérer du contenu enrichi',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Décrivez ce que vous souhaitez faire',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Enregistrer',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Envoyer',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Enregistrer',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Envoyer à AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - Sélectionné',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Supprimer',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Suggestions',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Assistant de rédaction',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Laissez Atlassian Intelligence vous aider à écrire',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Écrire',
  'fabric.editor.ai.shared.betaLabel': 'Bêta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BÊTA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOUVEAU',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Dire à AI :',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "Dire à l'agent",
};
